import type { CalculatorSet } from '@/components/customFields/types';
import type { AssetStoryblok, RichtextStoryblok } from '@/types/component-types-sb';
import type {
  GlobalAutostromRechnerStoryblok,
  GlobalGasRechnerStoryblok,
  GlobalHtntCalculatorStoryblok,
  GlobalStromRechnerStoryblok,
} from '@/types/component-types-sb';

export type CalculatorTabContent =
  | GlobalAutostromRechnerStoryblok
  | GlobalGasRechnerStoryblok
  | GlobalHtntCalculatorStoryblok
  | GlobalStromRechnerStoryblok;

/** Fields shared by calculator tab UIs (Storyblok → tab strip + panels). */
export interface CommonCalculatorFields {
  icon: AssetStoryblok;
  tabTitle?: string;
  title?: string;
  button: string;
  text?: RichtextStoryblok;
  hideFooterText?: boolean;
  uuid: string;
  id: number;
  content: CalculatorTabContent;
}

export function extractCalculatorTabFields(tabs: CalculatorSet): CommonCalculatorFields[] {
  const result: CommonCalculatorFields[] = [];
  for (const tab of tabs) {
    if (typeof tab === 'string' || !tab.content) {
      continue;
    }
    const { content } = tab;
    result.push({
      icon: content.icon,
      tabTitle: content.tab_headline || tab.name,
      title: content.title,
      button: content.button,
      text: content.text,
      hideFooterText: content.hide_footer_text,
      uuid: tab.uuid,
      id: tab.id,
      content: content as CalculatorTabContent,
    });
  }
  return result;
}
